import React from 'react';
import { Text } from '@/components/Typography';
import { ChatListItem as ChatRow } from '@/components/ChatListItem';
import { Plus32 } from '@/shared/icons';

export type ChatListItemData = {
  id: number | string;
  title: string;
  subtitle?: string;
};

export interface ChatListProps {
  title?: string;
  items: ChatListItemData[];
  loading?: boolean;
  error?: string | null;
  selectedId?: number | string | null;
  onSelect: (id: number | string) => void;
  onCreate?: () => void;
  emptyMessage?: string;
}

export const ChatList: React.FC<ChatListProps> = ({
  title = 'Chats',
  items,
  loading = false,
  error = null,
  selectedId = null,
  onSelect,
  onCreate,
  emptyMessage: _emptyMessage = 'No chats yet', // eslint-disable-line @typescript-eslint/no-unused-vars
}) => {
  return (
    <div>
      <Text variant="text-md-bold" className="text-grey-main dark:text-grey-plain px-4 py-[13px]">
        {title}
      </Text>

      {onCreate && (
        <div>
          <button
            type="button"
            className="w-full h-[48px] flex items-center gap-3 rounded hover:bg-grey-light hover:dark:bg-grey-main px-4
                        text-grey-main dark:text-grey-plain"
            onClick={() => onCreate?.()}
          >
            <Plus32 />
            <Text variant="text-md-regular">New chat</Text>
          </button>
        </div>
      )}

      {loading && (
        <Text variant="text-md-regular" className="text-grey-medium">
          Loading chats...
        </Text>
      )}

      {error && (
        <Text variant="text-md-regular" className="text-red-500">
          {error}
        </Text>
      )}

      {/* {!loading && !error && items.length === 0 && (
        <Text variant="text-md-regular" className="text-grey-medium px-4 py-3">
          {emptyMessage}
        </Text>
      )} */}

      {!loading &&
        items.map(c => (
          <div key={c.id} className="mt-1">
            <ChatRow
              title={c.title}
              subtitle={c.subtitle}
              isSelected={selectedId != null && String(selectedId) === String(c.id)}
              onClick={() => onSelect(c.id)}
            />
          </div>
        ))}
    </div>
  );
};

export default ChatList;
